export default (filename, blob) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    // Use special ms version if available to get it working on Edge.
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
        return;
    }

    if ('download' in HTMLAnchorElement.prototype) {
        const url = window.URL.createObjectURL(blob);

        // Use showSaveFilePicker API if available (Chrome, Edge)
        if (window.showSaveFilePicker) {
            const extension = filename.split('.').pop();
            const types = [];
            if (extension === 'sb3') {
                types.push({
                    description: 'Scratch 3 Project',
                    accept: {'application/x.scratch.sb3': ['.sb3']}
                });
            }
            window.showSaveFilePicker({
                suggestedName: filename,
                types: types.length > 0 ? types : undefined
            }).then(handle => {
                return handle.createWritable();
            }).then(writable => {
                return writable.write(blob).then(() => writable.close());
            }).catch(err => {
                // User cancelled - do nothing
                if (err.name !== 'AbortError') {
                    // Fallback to normal download
                    downloadLink.href = url;
                    downloadLink.download = filename;
                    downloadLink.type = blob.type;
                    downloadLink.click();
                }
            }).finally(() => {
                window.setTimeout(() => {
                    document.body.removeChild(downloadLink);
                    window.URL.revokeObjectURL(url);
                }, 1000);
            });
            return;
        }

        // Fallback for browsers without showSaveFilePicker
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.type = blob.type;
        downloadLink.click();
        window.setTimeout(() => {
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        }, 1000);
    } else {
        // iOS 12 Safari, open a new page and set href to data-uri
        let popup = window.open('', '_blank');
        const reader = new FileReader();
        reader.onloadend = function () {
            popup.location.href = reader.result;
            popup = null;
        };
        reader.readAsDataURL(blob);
    }
};